exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-breadcrumb__inner,\n.el-breadcrumb__inner a {\n  /*color: #fff;*/\n  color: rgb(217, 142, 106);\n}\n.el-breadcrumb__inner,\n.el-breadcrumb__inner a:hover {\n  color: #f0f3f7;\n}\n.el-breadcrumb__separator {\n  color: #fff;\n  color: rgb(217, 142, 106);\n}\n.app-breadcrumb.el-breadcrumb .no-redirect {\n  /*color: #f0f3f7!important;*/\n  cursor: pointer !important;\n}\n", ""]);

// exports
